export type ObjectWithType = {
	type: string;
};

export const isObjectWithType = (o: unknown): o is ObjectWithType =>
	typeof o === "object" && o !== null && "type" in o;
